import { Component, Input } from '@angular/core'
import { FormFieldComponent } from '@widgets/form-field/form-field.component'

@Component({
  styleUrls: ['checkbox-field.component.scss'],
  selector: 'bdg-checkbox-field',
  templateUrl: './checkbox-field.component.html',
})
export class CheckboxFieldComponent extends FormFieldComponent {
  @Input()
  centerAligned = true

  @Input()
  id: string

  constructor() {
    super()
  }

  onChange() {
    this.control.markAsTouched()
  }
}
